import { DTOError } from 'src/error/errors/DTOError';

import type { FlightOption } from './types';

import { availabilityDTO } from '../package/availabilityDTO';
import { flightOneWayInfoDTO } from './flightOneWayInfoDTO';
import { operatorInfoDTO } from './operatorInfoDTO';

export const flightOptionsDTO = (data: unknown): FlightOption[] => {
  if (data && Array.isArray(data)) {
    return data.map((flightOption) => flightOptionDTO(flightOption));
  }

  throw new DTOError('flightOptionsDTO', data);
};

const flightOptionDTO = (data: unknown): FlightOption => {
  if (
    data &&
    typeof data === 'object' &&
    'availability' in data &&
    'operator_info' in data &&
    'to' in data &&
    'back' in data
  ) {
    return {
      availability: availabilityDTO(data.availability),
      flight_pair_id:
        'flight_pair_id' in data && typeof data.flight_pair_id === 'string'
          ? data.flight_pair_id
          : '',
      fuel_charge:
        'fuel_charge' in data && typeof data.fuel_charge === 'number'
          ? data.fuel_charge
          : 0,
      is_cheapest:
        'is_cheapest' in data && typeof data.is_cheapest === 'boolean'
          ? data.is_cheapest
          : false,
      operator_info: operatorInfoDTO(data.operator_info),
      package_id:
        'package_id' in data && typeof data.package_id === 'string'
          ? data.package_id
          : '',
      tour_id:
        'tour_id' in data && typeof data.tour_id === 'string'
          ? data.tour_id
          : '',
      warning:
        'warning' in data && typeof data.warning === 'boolean'
          ? data.warning
          : false,
      warranty:
        'warranty' in data && typeof data.warranty === 'boolean'
          ? data.warranty
          : false,
      to: flightOneWayInfoDTO(data.to),
      back: flightOneWayInfoDTO(data.back),
    };
  }

  throw new DTOError('flightOptionDTO', data);
};
